/**
 * v0.1.0
 */

const CustomEvent = require("custom-event");
const NAMESPACE = "[js/helpers/gsntv]";
const GAME_ID = 5; //temporary to pass syntax errors

export function loginToGSNTV() {
  const { gsntvLoginFromIFrame } = window.parent;

  if (gsntvLoginFromIFrame) {
    console.log(NAMESPACE, "loginToGSNTV");

    gsntvLoginFromIFrame();
  }
}

export function logoutFromGSNTV() {
  const { gsntvLogoutFromIFrame } = window.parent;

  if (gsntvLogoutFromIFrame) {
    console.log(NAMESPACE, "logoutFromGSNTV");

    gsntvLogoutFromIFrame();
  }
}

/**
 * Get High Score
 */
export function highScoresFromGSNTV() {
  const { gsntvGetHighScores } = window.parent;

  if (gsntvGetHighScores) {
    console.log(NAMESPACE, "highScoresFromGSNTV");

    return gsntvGetHighScores(GAME_ID); // GAME_ID IS A GLOBAL.
  }

  return Promise.resolve({ scores: [] });
}

/**
 * Get Game Data
 */
export function userDataFromGSNTV() {
  const { gsntvGetUserData } = window.parent;

  if (gsntvGetUserData) {
    console.log(NAMESPACE, "gsntvGetUserData");
    return gsntvGetUserData(GAME_ID);
  }

  return Promise.resolve();
}

/**
 * Save Game Data
 * @param {string} data 
 */
export function saveUserDataToGSNTV(data) {
  const { gsntvSaveUserData } = window.parent;

  if (gsntvSaveUserData) {
    console.log("gsntvSaveUserData");
    return gsntvSaveUserData(GAME_ID, data);
  }

  return Promise.resolve();
}

/**
 * Save High Score
 * @param {Object} data 
 * @param {string} data.name - displayed name
 * @param {integer} data.highScore - displayed score
 */
export function saveHighScoreToGSNTV(data) {
  const { gsntvSaveScore } = window.parent;

  if (gsntvSaveScore) {
    console.log("gsntvSaveScore");
    const { name, highScore } = data;
    return gsntvSaveScore(GAME_ID, name, highScore);
  }
}

export function trackGAToGSNTV(data) {
  const { gsntvTrackGA } = window.parent;

  console.log("tracking:", data);

  if (gsntvTrackGA) {
    console.log("gsntvTrackGA");
    const { category, action, label, value } = data;
    return gsntvTrackGA(category, action, label, value);
  }
}

export function trackKruxToGSNTV(data) {
  const { gsntvTrackKrux } = window.parent;

  if (gsntvTrackKrux) {
    const { id, eventParam, dataDMP } = data;
    return gsntvTrackKrux(id, eventParam, dataDMP);
  }
}

export function isIframed() {
  return !!(window.parent && window.parent.gsntvLoginFromIFrame);
}

export function getSweepObject() {
  const hash = window.location.hash;

  switch (hash) {
    case "#comcast":
      return {
        source: "comcast-america-quiz",
        img: "images/nestle-banner-2.jpeg",
        alt: "Nestle"
      };
    case "#other":
      return {
        source: "other-america-quiz",
        img: "images/nestle-banner.png",
        alt: "Nestle"
      };
    default:
    case "#county-line-fence":
      return {
        source: "qanda-county-line-fence",
        img: "images/CountyLineFence_banner.png",
        alt: "County Line Fence",
        rulesLink: "/countylinefence/rules",
        footerBannerSrc: "images/america-says-banner.jpg",
        footerBannerAlt: "America Says"
      };
    case "#miracle-ear":
      return {
        source: "qanda-ultimate-hearing",
        img: "images/miracle-ear-banner.png",
        alt: "Miracle Ear",
        rulesLink: "/miracleear/rules",
        footerBannerSrc: "images/america-says-banner.jpg",
        footerBannerAlt: "America Says"
      };
    case "#hear-clear":
      return {
        source: "qanda-hear-clear",
        img: "images/nestle-banner.png",
        alt: "Hear Clear"
      };
  }
}

export function gsntvIframeCommunicationInit(store, actions) {
  const { userLogin, userLogout } = actions;

  // create event for user login from parent
  window.addEventListener("userlogin", event =>
    store.dispatch(userLogin(event))
  );
  // create event for user logout from parent
  window.addEventListener("userlogout", () => store.dispatch(userLogout()));

  window.parentResize = function(width, height) {
    console.log("parentResize", width, height);

    if (window.parent.gsntvFrameResize) {
      console.log("gsntvFrameResize");

      window.parent.gsntvFrameResize(width, height);
    }
  };

  window.gsntvLoginFromParent = function(data) {
    console.log("gsntvLoginFromParent", data);

    window.dispatchEvent(
      new CustomEvent("userlogin", {
        detail: data,
        bubbles: false,
        cancelable: false
      })
    );
  };

  window.gsntvLogoutFromParent = function() {
    console.log("gsntvLogoutFromParent");

    window.dispatchEvent(new CustomEvent("userlogout"));
  };

  window.gsntvUpdateMinHeight = function(minHeight) {
    console.log("gsntvUpdateMinHeight");

    var wrapper = document.getElementsByClassName("main_wrapper")[0];
    wrapper.style.minHeight = "calc(" + minHeight + " - 6.4rem)";
  };
}

export function gsntvCheckLogin(userLogin) {
  if (window.parent && window.parent.gsntvCheckLoginFromIFrame) {
    window.parent.gsntvCheckLoginFromIFrame().then(data => {
      console.log('gsntvCheckLogin', data);
      data && data.UID && userLogin({ detail: data, appInitiatedLogin: true });
    });
  }
}

/**
 * Gigya Login/Registratoin Form Submission Response
 * @param {json} data
 */
export function gigyaResponseSuccess(data) {
  return (
    data.eventName === "afterSubmit" &&
    data.response &&
    data.response.errorCode === 0
  );
}

export function gigyaResponseFormClosed(data) {
  return (
    data.eventName === "hide" && data.response && data.response.errorCode === 0
  );
}
